import axios from 'axios';

const cms_key = import.meta.env.VITE_APP_CMS_KEY;
const WEB_API_URL = `${import.meta.env.VITE_APP_API_URL}/v1`;

export const headers = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
  Authorization: `Bearer ${localStorage.getItem('cms_token')}`,
  'Cms-Key': cms_key,
};

if (!localStorage.getItem('cms_token')) {
  delete headers['Authorization'];
}

const createAPI = (
  baseURL = `${import.meta.env.VITE_APP_API_URL}/v1/cms`,
  config = {}
) => {
  const axiosInstance = axios.create({
    baseURL,
    withCredentials: false,
    headers: headers,
    ...config,
  });


  return axiosInstance;
};

const api = createAPI();
const webApi = createAPI(WEB_API_URL);

export { api, webApi };
